import { Modal } from 'antd'

interface ConfirmModalProps {
  okText: any
  onOk: () => void
  cancelText: any
  onCancel?: () => void
  color?: any
  title?: any
  content: any
  icon?: any
  width?: number
  centered?: boolean
}

export const ConfirmModal = ({
  okText = 'Ok',
  onOk = () => {},
  cancelText = 'Cancel',
  onCancel = () => {},
  color = 'primary',
  title = '',
  content = '',
  icon = null,
  width = 500,
  centered = true,
}: ConfirmModalProps) => {
  Modal.confirm({
    title,
    icon,
    content,
    width,
    okText,
    okButtonProps: {
      color,
    },
    onOk,
    cancelText,
    cancelButtonProps: {
      color,
    },
    onCancel,
    centered,
  })
}
